import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { UsuarioListaLookupsResponse } from '../../responses/usuario/usuario-lista-lookups.response';

@Injectable({
  providedIn: 'root',
})
export class UsuarioLookupService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(): Observable<UsuarioListaLookupsResponse> {
    let uri: string = `Lookup/admin`;

    return this.httpClient
      .get<UsuarioListaLookupsResponse>(environment.urlApiUsuario + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
